<template>
  <div class="number-modal">
    <div class="number-modal-body">
      <div class="number-body" style="margin-top: 20px">
        <div class="number-body-close">
          <img
            src="@/assets/icon/shapes-and-symbols.png"
            alt=""
            @click="remove"
          />
        </div>
        <div class="number-body-title">
          <p>
            {{ phoneNumber }} утасны дугаар луу илгээсэн баталгаажуулах код
            оруулах
          </p>
        </div>
        <div class="number-body-form">
          <form action="" @submit.prevent="sendNumber">
            <input
              type="text"
              placeholder="Баталгаажуулах код оруулна уу"
              v-model="number"
            />
            <div class="number-error" v-if="error">
              <p>{{ errorMessage }}</p>
            </div>
            <div class="btns">
              <input
                type="submit"
                value="БАТАЛГААЖУУЛАХ"
                class="btn login-btn"
                :disabled="isDisabled"
                :class="{ someSpace: error }"
              />
              <span class="resend-text" @click="resendMsg">Дахин илгээх</span>
            </div>
            <div class="msg">
              <p>{{ successMessage }}</p>
            </div>
          </form>
        </div>
      </div>
      <div class="number-footer">
        <p>
          Утасны дугаар оруулснаар дараагийн удаад нэвтрэх түлхүүр үг болох
          боломжтой.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "@/EventBus.js";
export default {
  props: ["phoneNumber"],
  data() {
    return {
      number: "",
      error: false,
      errorMessage: "",
      isDisabled: false,
      successMessage: "",
      message: true,
    };
  },
  methods: {
    hideSuccessMessage() {
      (this.successMessage = ""), (this.successModal = false);
    },
    RedirectLogin() {
      EventBus.$emit("GLOBAL_ERROR", "error");
    },
    sendNumber() {
      this.isDisabled = true;
      this.$insProgress.start();
      var userNumber = this.number.replace(/\s/g, "");
      var isnum = /^\d+$/.test(userNumber);
      if (userNumber.length === 4 && isnum) {
        let tokenId = localStorage.getItem("authToken");
        if (tokenId == null) {
          this.RedirectLogin();
          this.$auth.destroyToken();
          this.$auth.removeMe();
          this.$router.push({ name: "login" });
        }
        var secureCode = this.number;
        this.$bonusApi
          .post(
            `auth/check/code/phone`,
            {
              tokenId,
              phoneNumber: this.phoneNumber,
              code: secureCode,
              type: "IdPhone",
            },
            {
              headers: {
                "Content-Type": "application/json",
                "Accept-Language": "mn",
              },
            }
          )
          .then((response) => {
            if (response.data === true) {
              this.$emit("endNumber");
              this.$insProgress.finish();
            } else {
              this.isDisabled = false;
              this.errorMessage = "Баталгаажуулах код буруу байна.";
              this.error = true;
              this.$insProgress.finish();
            }
          })
          .catch((error) => {
            this.isDisabled = false;
            this.errorMessage =
              (error.response && error.response.data && error.response.data.message) ||
              "Баталгаажуулах код буруу байна.";
            this.error = true;
            this.$insProgress.finish();
          });
      } else {
        this.error = true;
        this.errorMessage = "Та зөвхөн 4 оронтой тоо оруулна уу ?";
        this.isDisabled = false;
        this.$insProgress.finish();
      }
    },
    resendMsg() {
      this.$insProgress.start();
      let tokenId = localStorage.getItem("authToken");
      if (tokenId == null) {
        this.$auth.destroyToken();
        this.$auth.removeMe();
        this.$router.push({ name: "login" });
      }
      let typeValue = this.phoneNumber;
      let userOwnData = this.$auth.getMe();
      let cardHolderKey = userOwnData.cardHolderInfId;
      this.$bonusApi
        .post(
          `auth/send/code/phone`,
          {
            tokenId,
            phoneNumber: typeValue,
            cardHolderKey,
            type: "IdPhone",
          },
          {
            headers: {
              "Content-Type": "application/json",
              "Accept-Language": "mn",
            },
          }
        )
        .then((response) => {
          if (response.data === true) {
            this.successMessage = "Амжилттай илгээгдлээ";
            this.message = true;
            this.$insProgress.finish();
          }
        })
        .catch((error) => {
          this.successMessage =
            (error.response && error.response.data && error.response.data.message) ||
            "Код илгээхэд алдаа гарлаа.";
          this.message = true;
          this.$insProgress.finish();
        });
    },
    remove() {
      this.$emit("remove");
    },
  },
};
</script>

<style scoped>
.btns {
  width: 100%;
  height: 58px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
}
.btns input,
span {
  flex: 1;
}
.resend-text {
  font-size: 13px;
  height: 38px;
  margin-top: 20px;
  color: #1660ab;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
}
.msg {
  width: 100%;
  height: auto;
  margin-top: 10px;
  font-size: 13px;
  color: #ed3237;
}
.number-body-close {
  padding-left: 54px;
  text-align: right;
  padding-right: 33px;
  margin-bottom: 10px;
}
.number-body-close img {
  width: 15px;
  height: 15px;
  cursor: pointer;
}
</style>
